import axios from '../../../plugins/axios'

const get = (params, config = {}) => axios.get('/api/v1/builds', { params, ...config });

const find = (id, config = {}) => axios.get(`/api/v1/builds/${id}?history=true`, config);

const purge = (id) => axios.delete(`/api/v1/builds/${id}`);

const update = (id, data) => axios.put(`/api/v1/builds/${id}`, data);

const getByApplicationId = (id, params, config = {}) => axios.get(`/api/v1/applications/${id}/builds`, { params, ...config });

const rollback = (id, data ) => axios.put(`/api/v1/builds/${id}/rollback`, data);

const restart = (id) => axios.post(`/api/v1/builds/${id}/restart`, {});

const getFailureLog = (id, params, config = {}) => axios.get(`/api/v1/builds/${id}/failure-log`, { params, ...config });

export default {
  get,
  find,
  purge,
  update,
  getByApplicationId,
  rollback,
  restart,
  getFailureLog,
}
